import { MedewerkerType } from "../../../enums";

/**
 * B7 (28-09-2026): een bestaande deadline (taak of wachten) verschuiven mag
 * alleen admin, management en PM; hetzelfde geldt voor de startdatum van een
 * bestaande taak. Gelijk aan de backend (`hasElevatedDossierAccess` in
 * `domain/dossier-access.ts`); de server weigert andere rollen met 403, het
 * scherm volgt alleen.
 */
export const DEADLINE_VERSCHUIVEN_ROLLEN: MedewerkerType[] = [
  MedewerkerType.PM,
  MedewerkerType.MANAGER,
  MedewerkerType.ADMIN,
  MedewerkerType.INPLANNER,
  MedewerkerType.FINANCIELE_MANAGER,
];
